import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  font-weight: 600;\n  font-size: 15px;\n  color: ', ';\n  text-align: ', ';\n  display: ', ';\n'], ['\n  font-weight: 600;\n  font-size: 15px;\n  color: ', ';\n  text-align: ', ';\n  display: ', ';\n']);

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export var StyledFormErrorMessage = styled.p(_templateObject, function (props) {
  return props.theme.dormifyRed;
}, function (props) {
  return props.align ? props.align : 'left';
}, function (props) {
  return props.hide ? 'none' : 'block';
});

var ErrorMessage = React.forwardRef(function (props, ref) {
  return React.createElement(StyledFormErrorMessage, { hide: props.hide, ref: ref, align: props.align });
});

ErrorMessage.displayName = 'ErrorMessage';

ErrorMessage.propTypes = {
  align: PropTypes.string,
  hide: PropTypes.bool
};

export default ErrorMessage;